import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

declare var $: any;

@Injectable({ providedIn: 'root' })
export class HubService {
  public get isDianaSuisseAvailable(): boolean {
    return this._isDianaSuisseAvailable;
  }
  private _isDianaSuisseAvailable: boolean = false;

  private connection: any;
  private interactionProxy: any;

  constructor(private ngZone: NgZone, private router: Router) {}

  init(): void {
    $.connection.hub.logging = true;

    const hubUrl = environment.hubUrl;

    this.connection = $.hubConnection(hubUrl);
    this.interactionProxy = this.connection.createHubProxy('InteractionHub');

    this.registerInteractionEvents();
  }

  connect(): void {
    this.connection
      .start()
      .done((info: any) => {
        console.log(
          'CONNECTED to signalr hub',
          info.url,
          'using',
          info.transport.name
        );
        this.ngZone.run(() => {
          this._isDianaSuisseAvailable = true;
        });

        this.registerWebClient();
      })
      .fail(() => (this._isDianaSuisseAvailable = false));
  }

  disconnect(): void {
    console.log('STOPPING SignalR connection');
    this.deregisterInteractionEvents();
    this.connection.stop(true /* async */, true /* notifyServer */);
  }

  /**
   * Triggers an action in DianaSuisse over Hub.
   * Action can be executed with the `action` iteself and one or many arguments (`args`)
   * @param actionName The action itself
   * @param args one or many arguments for the action
   */
  executeAction(actionName: string, args: string = ''): void {
    console.log(`executeAction; Action: ${actionName}, Parameter: ${args}`);

    this.interactionProxy
      .invoke('DispatchActionToClient', actionName, args)
      .done(() => {
        console.log('action executed');
      });
  }

  registerWebClient(): void {
    if (this.connection.state === $.signalR.connectionState.connected) {
      this.interactionProxy.invoke('RegisterWebClient').done(() => {
        // console.log('registerWebClient');
      });
    }
  }

  public onActionRecieved(name: string, args: string | null): void {
    switch (name) {
      case 'openAgenda': {
        if (args) {
          const params = args.split('='); // e.g. date=01.04.2022
          if (params[1]?.length > 0) {
            this.router.navigate(['/calendar'], {
              queryParams: { date: params[1] }
            });
            break;
          }
        }
        this.router.navigate(['/calendar']);
        break;
      }
      case 'openMedicalHistory': {
        const params = args!.split('='); // e.g. customerId=b9279d10-7af7-4c73-8ea2-bb1165f73d92
        this.router.navigate(['/medical-history', params[1]]);
        break;
      }
    }
  }

  private registerInteractionEvents(): void {
    this.interactionProxy.on(
      'ActionRequested',
      (name: string, args: string) => {
        this.ngZone.run(() => {
          console.log(name, args);
          this.onActionRecieved(name, args);
        });
      }
    );
  }

  private deregisterInteractionEvents(): void {
    this.interactionProxy.off('ActionRequested');
  }
}
